export class CloseTransferDetailsRequest {
	transferId: number;
	details: DetailClosureTransfer[];
}

export class DetailClosureTransfer {
	detailId: number;
	quantityReceived: number;
	comment: string;
}

export class TransferRequestedResponse {
	companyId: number;
	creationDate: number;
	description: string;
	documentNumber: any;
	executed: boolean;
	expectedDate: number;
	fromWarehouse: number;
	id: number;
	issuedDate: number;
	receptionDate: number;
	toWarehouse: number;
	transfer: boolean;
	transformation: boolean;
	//only for frontend
	details!: TransferRequestedDetailResponse[];
}

export class TransferRequestedDetailResponse {
	detailId: number;
    transferId: number;
    productId: number;
    productName: string;
    existencePrevious: number;
    quantityRequest: number;
    quantityReceived: number;
    comment: string;
	//only for frontend
	userQuantity!: number;
	type!: string;
	showComment!: boolean;
}

export interface TransferRequestedSummaryResponse {
	id: number;
	code: string;
	name: string;
	totalPurchases: number;
	totalTranslateIn: number;
	totalIn: number;
	totalSales: number;
	totalTranslateOut: number;
	totalOut: number;
	totalQuantityIn: number;
	totalQuantityOut: number;
	totalProductsIn: number;
	totalProductsOut: number;
}

export interface InventoryQuantityByProductResponse {
    productId: number;
    productCode: string;
    productName: string;
    totalQuantity: number;
}